<template>
  <div class="countdown" v-html="CountDown"></div>
</template>

<script>
export default {
  data () {
    return {
      status: null,
      CountDown: ''
    }
  },
  methods: {
    replaceText (text, source, target) {
      if (text.indexOf(source) > -1) {
        return text.replace(source, `${target}`)
      } else {
        return text
      }
    },
    getTimeText (endTime) {
      let nowTime = new Date().getTime() / 1000
      if (endTime <= nowTime) {
        // 活动已结束
        return this.$bus.transify['TOAST_EVENT_END']
      } else {
        let seconds = Math.floor(endTime - nowTime)
        let { days, hours, mins, secs } = {
          days: Math.floor((seconds / 86400) % 365),
          hours: Math.floor((seconds / 3600) % 24),
          mins: Math.floor((seconds / 60) % 60),
          secs: Math.floor(seconds % 60)
        }
        if (hours < 10) {
          hours = '0' + hours
        }
        if (mins < 10) {
          mins = '0' + mins
        }
        if (secs < 10) {
          secs = '0' + secs
        }
        return this.replaceText(
          this.replaceText(this.$bus.transify['T_P_TIME_CTDOWN'], ':day', days),
          ':time', `${hours} : ${mins} : ${secs}`
        )
      }
    }
  },
  mounted () {
    this.CountDown = this.getTimeText(this.$bus.actInfo.endTime)
    setInterval(() => {
      this.CountDown = this.getTimeText(this.$bus.actInfo.endTime)
    }, 1000)
  }
}
</script>

<style lang="scss" scoped>
.countdown {
  @include px2res(width, 1038);
  @include px2res(height, 44);
  @include px2res(line-height, 44);
  @include px2res(font-size, 24);
  margin: 0 auto;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/countdown/index.vue